import { JwtAxios } from '@/packaging';

export const addonAPI = {
  /** 판매중인 부가서비스 상품목록 (host별 노출) */
  GetSaleAddonProductList: async host => {
    const res = await JwtAxios.get(
      `/AddonProduct/GetSaleAddonProductList?host=${encodeURIComponent(host || '')}`
    );
    return res;
  },
  /** 부가서비스 상품 상세 (옵션 포함) */
  GetAddonProductDetail: async idx => {
    const res = await JwtAxios.get(`/AddonProduct/GetAddonProductDetail?idx=${idx}`);
    return res;
  },
  /** 주문 생성. 금액은 서버가 다시 계산한다. */
  CreateAddonOrder: async body => {
    const res = await JwtAxios.post('/AddonPayment/CreateAddonOrder', body);
    return res;
  },
  /** 마일리지 결제 확정 */
  PayAddonByMileage: async orderId => {
    const res = await JwtAxios.post('/AddonPayment/PayAddonByMileage', { order_id: orderId });
    return res;
  },
  /** 내 부가서비스 주문내역 */
  GetMyAddonOrderList: async (page = 1, row = 20) => {
    const res = await JwtAxios.get(`/AddonPayment/GetMyAddonOrderList?page=${page}&row=${row}`);
    return res;
  },
  /** 관리자가 지정한 PG(이니시스/KCP) 설정 */
  GetPgConfig: async () => {
    const res = await JwtAxios.get('/PaymentSetting/GetPgConfig');
    return res;
  }
};
